"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Heading = _interopRequireDefault(require("../Heading"));
var _createStyles = require("../styles/createStyles");
const _excluded = ["children", "classes", "className", "disableTypography", "subheader", "subheaderTypographyProps", "title", "titleTypographyProps"];
const useStyles = exports.useStyles = (0, _createStyles.createStyles)(_ref => {
  let {
    theme
  } = _ref;
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      minHeight: theme.busbud.spacing(7),
      padding: theme.busbud.spacing(1, 2.5),
      [theme.busbud.breakpoints.up('md')]: {
        minHeight: theme.busbud.spacing(8),
        padding: theme.busbud.spacing(2, 3.5)
      }
    },
    leftContentContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      flexGrow: 1,
      flexShrink: 1
    },
    /* Styles applied to the left content wrapper element. */
    leftContent: {
      minWidth: 0,
      overflow: 'hidden'
    },
    rightContentContainer: {
      display: 'flex',
      flexShrink: 0,
      alignItems: 'center'
    },
    /* Styles applied to the right content wrapper element. */
    rightContent: {
      minWidth: 0,
      overflow: 'hidden'
    },
    /* Styles applied to the title Typography element. */
    title: {},
    /* Styles applied to the subheader Typography element. */
    subheader: {}
  };
});
/**
 * **❗️ DEPRECATED**: Use the new `Card.Header` component from `@busbud/horizon` - [Storybook](https://main--66e336a480b3d19fa782310f.chromatic.com/?path=/docs/data-display-card-card-header):
 *
 * ```tsx
 * import { Card } from "@busbud/horizon";
 * ```
 *
 * [Storybook](https://busbud.github.io/horizon-web-ui-kit/?path=/docs/data-display-card-card-header)
 *
 * @deprecated
 */
const CardHeader = /*#__PURE__*/_react.default.forwardRef(function CardHeader(props, ref) {
  const {
      children,
      classes: classesOverrides,
      className,
      disableTypography = false,
      subheader: subheaderProp,
      subheaderTypographyProps,
      title: titleProp,
      titleTypographyProps
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    classes,
    cx
  } = useStyles({
    classesOverrides
  });
  const title = !titleProp || disableTypography ? titleProp : /*#__PURE__*/_react.default.createElement(_Heading.default, (0, _extends2.default)({
    "data-testid": "cardHeaderTitle",
    component: "span",
    size: "xs",
    color: "text.primary.opaque",
    display: "block",
    fontWeight: "bold",
    noWrap: true,
    className: classes.title
  }, titleTypographyProps), titleProp);
  const subheader = !subheaderProp || disableTypography ? subheaderProp : /*#__PURE__*/_react.default.createElement(_Heading.default, (0, _extends2.default)({
    "data-testid": "cardHeaderSubheader",
    component: "span",
    size: "xxs",
    color: "text.quaternary.opaque",
    display: "block",
    fontWeight: "medium",
    noWrap: true,
    className: classes.subheader
  }, subheaderTypographyProps), subheaderProp);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: cx(classes.root, className),
    ref: ref
  }, other), /*#__PURE__*/_react.default.createElement("div", {
    className: cx(classes.leftContentContainer, classes.leftContent)
  }, title, subheader), children ? /*#__PURE__*/_react.default.createElement("div", {
    className: cx(classes.rightContentContainer, classes.rightContent)
  }, children) : null);
});
var _default = exports.default = CardHeader;